import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";

export const landingMaterialImports = [
  MatButtonModule,
  MatIconModule,
  MatMenuModule,
  MatTooltipModule,
] as const;
